module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073ec_banner_800x600.1ac3a1ad.png";